import { ReactElement } from 'react';

import Title from 'components/Title/Title';

import { AuthSteps } from 'constants/enums';

interface AuthTitleProps {
  authStep: AuthSteps;
}

const AuthTitle = ({ authStep }: AuthTitleProps): ReactElement => {
  const titles = {
    [AuthSteps.CheckEmail]: 'Sign Up or Log In Today!',
    [AuthSteps.Login]: 'Sign Up or Log In Today!',
    [AuthSteps.Registration]:
      'Skip the Search — We’ll bring the opportunities to you!'
  };

  const subtitles = {
    [AuthSteps.CheckEmail]:
      'Enter your email to access or create your account and join our marketplace.',
    [AuthSteps.Login]:
      'Enter your email to access or create your account and join our marketplace.',
    [AuthSteps.Registration]:
      'Share your details, and we’ll connect you with the right opportunities.'
  };

  return <Title title={titles[authStep]}>{subtitles[authStep]}</Title>;
};

export default AuthTitle;
